import * as PIXI from 'pixi.js'
import * as CSS from 'utils/css.js'
import * as Utils from 'utils/math.js'
import TweenMax from 'gsap'
import Detector from 'utils/Detector'
import MaskFilter from 'filters/Mask/MaskFilter'
import Emitter from 'core/Emitter'
import SoundManager from 'components/SoundManager'
export default class Cover {
  constructor (opts) {
    this.size = opts.size
    this.renderer = opts.renderer
    this.resources = opts.resources
    this.scene = opts.scene
    this.offsetHeight = 0
    this.prefix = CSS.getPrefix()
    this.isHidden = true
    this.isReady = false
    this.soundManager = new SoundManager()

    this.isMobile = Detector.isMobile()

    this.scrollY = {
      dest: 0,
      current: 0
    }

    this.oldPosition = 0

    this.dom = {
      coverSection: document.querySelector('.cover-section'),
      // coverSpacer: document.querySelector('.cover-spacer'),
      coverContainer: document.querySelector('.cover-section .cover-container'),
      coverJardins: document.querySelector('.cover-section .cover-container__jardins'),
      coverGradient: document.querySelector('.cover-section .cover-container__background-gradient'),
      coverTitle: document.querySelector('.cover-section .cover-container__title'),
      coverCta: document.querySelector('.cover-section .cover-container__cta'),
      coverForeground: document.querySelector('.cover-section .cover-container__foreground'),
      coverForegroundPlantLeft: document.querySelector('.cover-section .cover-container__foreground .foreground__plant-left'),
      coverForegroundPlantRight: document.querySelector('.cover-section .cover-container__foreground .foreground__plant-right')
    }

    this.bounds = {
      originalBackgroundCoverSize: null,
      coverSection: null,
      coverJardins: null,
      coverContainer: null,
      coverForeground: null,
      coverForegroundPlantLeft: null,
      coverForegroundPlantRight: null
    }

    this.motions = {
      easePlantLeft: 0,
      easePlantRight: 0,
      rotationPlantLeft: 0,
      rotationPlantRight: 0,
      maxRotationPlantLeft: -20,
      maxRotationPlantRight: 15,
      maxTitleOpacity: 1,
      minTitleOpacity: 0.2,
      minCTAOpacity: 0,
      maxCTAOpacity: 1,
      maxTitleScale: 1,
      minTitleScale: 0.85,
      titleOpacity: 0,
      titleScale: 0,
      ctaOpacity: 1,
      introSoundVolume: 0.5
    }

    this.renderTextureMask = PIXI.RenderTexture.create(this.size.w, this.size.h)

    this.container = new PIXI.Container()
    this.scene.addChild(this.container)

    this.createBackground()
    this.createMask()
  }

  createBackground () {
    this.backgroundBlack = new PIXI.Graphics()
    this.backgroundBlack.beginFill(0x091726)
    this.backgroundBlack.drawRect(0, 0, this.size.w, this.size.h)
    this.backgroundBlack.endFill()
    this.container.addChild(this.backgroundBlack)

    this.backgroundCover = new PIXI.Sprite(PIXI.Texture.fromFrame(`homer_cover_jardins`))
    this.backgroundCover.anchor.set(0.5)
    this.bounds.originalBackgroundCoverSize = {
      width: this.backgroundCover.texture.width,
      height: this.backgroundCover.texture.height,
      ratio: this.backgroundCover.texture.width / this.backgroundCover.texture.height
    }
    this.container.addChild(this.backgroundCover)

    // this.jardinsSprite = new PIXI.Sprite(PIXI.Texture.fromFrame('home_logo_jardins'))
    // this.jardinsSprite.anchor.set(0.5)
    // this.bounds.originalJardinsSize = {
    //   width: this.jardinsSprite.texture.width,
    //   height: this.jardinsSprite.texture.height,
    //   ratio: this.jardinsSprite.texture.width / this.jardinsSprite.texture.height
    // }
    // this.backgroundCover.addChild(this.jardinsSprite)
  }

  createMask () {
    this.maskCoverBg = new PIXI.Graphics()
    this.maskCoverBg.beginFill(0x000000)
    this.maskCoverBg.drawRect(0, 0, this.size.w, this.size.h)
    this.maskCoverBg.endFill()

    this.thresholdSprite = new PIXI.Sprite(PIXI.Texture.fromFrame(`threshold`))
    this.thresholdSprite.width = this.size.w
    this.thresholdSprite.height = this.size.h

    let maskCoverContainer = new PIXI.Container()
    maskCoverContainer.addChild(this.maskCoverBg)
    maskCoverContainer.addChild(this.thresholdSprite)

    this.renderer.render(maskCoverContainer, this.renderTextureMask)

    this.maskCoverSprite = new PIXI.Sprite(this.renderTextureMask)
    this.maskCoverSprite.width = this.size.w
    this.maskCoverSprite.height = this.size.h

    this.maskCoverFilter = new MaskFilter(this.maskCoverSprite)
    this.backgroundCover.filters = [this.maskCoverFilter]

    this.container.addChild(this.maskCoverSprite)

    if (window.APP_ALREADY_INIT) {
      this.maskCoverFilter.uniforms.alpha = 0
      let tl = new TimelineMax({
        onComplete: () => {
          this.backgroundCover.filters = null
          this.container.removeChild(this.maskCoverSprite)
          // document.body.classList.remove('locked')
          // document.body.classList.remove('black')
          // document.body.classList.add('beige')
        }
      })
      tl.to(this.maskCoverFilter.uniforms, 1.5, {
        alpha: 1,
        ease: Cubic.easeOut
      }, 'start')
      tl.from(this.dom.coverJardins, 1, {
        autoAlpha: 0,
        scale: 0.95,
        ease: Sine.easeOut
      }, 'start+=0.2')
      TweenMax.set(this.dom.coverTitle, {
        scale: this.motions.minTitleScale,
        opacity: this.motions.minTitleOpacity
      })

      // this.container.oldCacheAsBitmap = true
      // this.backgroundCover.cacheAsBitmap = true

      this.isReady = true
      document.body.classList.remove('locked')
      document.body.classList.remove('black')
      document.body.classList.add('beige')
    } else {
      this.maskCoverFilter.uniforms.alpha = 0

      document.body.classList.add('locked')

      this.showCoverSection()

      TweenMax.to(this.maskCoverFilter.uniforms, 3, {
        alpha: 1,
        ease: Cubic.easeOut,
        onComplete: () => {
          window.APP_ALREADY_INIT = true
          this.backgroundCover.filters = null
          this.container.removeChild(this.maskCoverSprite)
          // this.container.oldCacheAsBitmap = true
          // this.backgroundCover.cacheAsBitmap = true

          document.body.classList.remove('black')
          document.body.classList.add('beige')
        }
      })
    }
  }

  showCoverSection () {
    TweenMax.set(this.dom.coverTitle, {
      scale: this.motions.minTitleScale,
      opacity: this.motions.minTitleOpacity
    })

    this.showDom()
    let tl = new TimelineMax({
      onStart: () => {
        // SOUND PLAY INTRO
        Emitter.emit('SOUND::PLAYINIT', {intro: true})
      },
      onComplete: () => {
      }
    })

    tl.addLabel('start', '+=1.5')

    tl.from(this.dom.coverJardins, 3, {
      autoAlpha: 0,
      scale: 0.95,
      ease: Sine.easeOut,
      onComplete: () => {
        this.isReady = true
        document.body.classList.remove('locked')
      }
    }, 'start+=0.2')
    // .from(this.dom.coverGradient, 1, {
    //   autoAlpha: 0,
    //   ease: Cubic.easeInOut
    // }, 0)
    .staggerFrom([this.dom.coverCta.children], 2, {
      autoAlpha: 0,
      y: -10,
      ease: Cubic.easeOut
    }, -0.1)
    // .to(this.dom.coverSection, 1, {
    //   autoAlpha: 1,
    //   ease: Expo.easeOut,
    //   onComplete: () => {
    //     this.isReady = true
    //     document.body.classList.remove('locked')
    //     document.body.classList.remove('black')
    //     document.body.classList.add('beige')
    //   }
    // }, 'start')
  }

  getBounds () {
    this.bounds.coverContainer = CSS.getSize(this.dom.coverContainer)
    // this.bounds.coverSpacer = CSS.getSize(this.dom.coverSpacer)
    this.bounds.coverContainer.top = this.dom.coverContainer.offsetTop

    this.bounds.coverForegroundPlantLeft = CSS.getSize(this.dom.coverForegroundPlantLeft)
    this.bounds.coverForegroundPlantLeft.top = this.dom.coverForegroundPlantLeft.offsetTop
    this.bounds.coverForegroundPlantLeft.left = this.dom.coverForegroundPlantLeft.offsetLeft

    this.bounds.coverForegroundPlantRight = CSS.getSize(this.dom.coverForegroundPlantRight)
    this.bounds.coverForegroundPlantRight.top = this.dom.coverForegroundPlantRight.offsetTop
    this.bounds.coverForegroundPlantRight.right = this.size.w - (this.dom.coverForegroundPlantRight.offsetLeft + this.bounds.coverForegroundPlantRight.width)
  }

  positionDom () {
    this.dom.coverContainer.style.top = `${this.size.h}px`

    let size = Math.min(this.size.h * 0.6, (this.isMobile) ? this.size.w * 0.75 : 650)
    let halfSize = size / 2
    this.dom.coverJardins.style.height = `${size}px`
    this.dom.coverJardins.style.width = `${size}px`

    this.dom.coverJardins.style.top = `${(-this.size.h) + (this.size.h / 2) - halfSize}px`
    this.dom.coverJardins.style.left = `${(this.size.w / 2) - halfSize}px`

    // this.dom.coverSpacer.style.top = `${this.dom.coverContainer.offsetTop + this.dom.coverContainer.offsetHeight}px`
  }

  positionBackgroundCover () {
    let ratioBox = this.size.w / this.size.h

    if (ratioBox < this.bounds.originalBackgroundCoverSize.ratio) {
      let ratioH = this.size.h / this.bounds.originalBackgroundCoverSize.height
      this.backgroundCover.scale.set(ratioH)
    } else {
      let ratioW = this.size.w / this.bounds.originalBackgroundCoverSize.width
      this.backgroundCover.scale.set(ratioW)
    }

    this.backgroundCover.position.x = this.size.w / 2
    this.backgroundCover.position.y = this.size.h / 2

    // let ratioH = Math.min(this.size.h / this.bounds.originalBackgroundCoverSize.height, (this.size.h * 0.85) / this.bounds.originalBackgroundCoverSize.height)
    // this.jardinsSprite.scale.set(ratioH)

    this.backgroundBlack.width = this.size.w
    this.backgroundBlack.height = this.size.h
    // if (ratioBox < this.bounds.originalJardinsSize.ratio) {
    //
    // } else {
    //   let ratioW = Math.min(this.size.w / this.bounds.originalBackgroundCoverSize.width, (this.size.w * 0.8) / this.bounds.originalBackgroundCoverSize.width)
    //   this.jardinsSprite.scale.set(ratioW)
    // }
  }

  showDom () {
    if (!this.isHidden) return

    this.isHidden = false
    this.dom.coverSection.classList.remove('is-hidden')
  }

  hideDom () {
    if (this.isHidden) return

    this.isHidden = true
    this.dom.coverSection.classList.add('is-hidden')
  }

  update ({time, scrollY}) {
    if (!this.isReady) return
    this.scrollY = scrollY

    let limitIn = (this.bounds.coverContainer.top - this.size.h)
    let limitOut = limitIn + this.bounds.coverContainer.height + (this.size.h / 2 - this.bounds.coverContainer.height / 2)
    let limitOutVp = limitIn + this.bounds.coverContainer.height + this.size.h

    let vp = this.scrollY.current >= limitIn && this.scrollY.current <= limitOutVp
    if (vp && this.isReady) {
      this.showDom()
      // this.dom.coverSection.style[this.prefix] = CSS.getTransform(-this.scrollY.current)

      if (this.oldPosition !== -this.scrollY.current) {
        this.oldPosition = -this.scrollY.current
        this.dom.coverSection.style[this.prefix] = CSS.getMatrixTransform(0, this.oldPosition)
      }

      // // this.jardinsSprite.position.y = (-this.scrollY.current * 0.1)
      let norm = Utils.clamp((this.scrollY.current - limitIn - (this.size.h / 3)) / (limitOut - (this.size.h / 3)), 0, 1)
      let multiplier = (this.isMobile) ? 4 : 1.5

      let xLeft = -norm * (this.bounds.coverForegroundPlantLeft.left * multiplier)
      let xRight = norm * (this.bounds.coverForegroundPlantRight.right * multiplier)

      let leftRotation = norm * this.motions.maxRotationPlantLeft
      let rightRotation = norm * this.motions.maxRotationPlantRight

      this.motions.easePlantLeft += (xLeft - this.motions.easePlantLeft) * 0.15
      this.motions.easePlantLeft = Utils.round(this.motions.easePlantLeft)

      this.motions.easePlantRight += (xRight - this.motions.easePlantRight) * 0.15
      this.motions.easePlantRight = Utils.round(this.motions.easePlantRight)

      this.motions.rotationPlantLeft += ((leftRotation - this.motions.rotationPlantLeft) * 0.1)
      this.motions.rotationPlantRight += ((rightRotation - this.motions.rotationPlantRight) * 0.1)

      this.dom.coverForegroundPlantLeft.style[this.prefix] = CSS.getMatrixTransform(this.motions.easePlantLeft, 0, 1, this.motions.rotationPlantLeft)
      this.dom.coverForegroundPlantRight.style[this.prefix] = CSS.getMatrixTransform(this.motions.easePlantRight, 0, 1, this.motions.rotationPlantRight)

      let opacityTitle = this.motions.minTitleOpacity + (norm * (this.motions.maxTitleOpacity - this.motions.minTitleOpacity))
      this.motions.titleOpacity += (opacityTitle - this.motions.titleOpacity) * 0.15
      //
      let scaleTitle = this.motions.minTitleScale + (norm * (this.motions.maxTitleScale - this.motions.minTitleScale))
      this.motions.titleScale += (scaleTitle - this.motions.titleScale) * 0.15

      if (this.motions.titleOpacity < 1) {
        let stylesTitle = {}
        stylesTitle[this.prefix] = CSS.getMatrixTransform(0, 0, this.motions.titleScale)
        stylesTitle.opacity = Utils.round(this.motions.titleOpacity, 1e3)

        Object.assign(this.dom.coverTitle.style, stylesTitle)
      }

      //
      // // this.dom.coverTitle.style[this.prefix] = CSS.getTransform(0, 0, 0, this.motions.titleScale)
      //

      let normFade = Utils.clamp((this.scrollY.current - limitIn - (this.size.h / 3)) / (limitOut), 0, 1)
      let introFade = 0.5 - (normFade * 0.5)
      this.motions.introSoundVolume += (introFade - this.motions.introSoundVolume) * 0.15
      this.soundManager.fadeIntro(this.motions.introSoundVolume)

      let normOpacity = Utils.clamp((this.scrollY.current - limitIn) / (limitOut - (this.size.h / 3)), 0, 1)
      let opacityCTA = 1 - (normOpacity * (this.motions.maxCTAOpacity))
      this.motions.ctaOpacity += (opacityCTA - this.motions.ctaOpacity) * 0.15

      let alpha = Utils.round(this.motions.ctaOpacity, 1e3)

      if (alpha > 0) {
        this.dom.coverCta.style.opacity = alpha

        this.backgroundCover.alpha = Utils.clamp(alpha, 0.1, 1)

        let stylesJardins = {}
        stylesJardins[this.prefix] = CSS.getMatrixTransform(0, (-this.scrollY.current * 0.1))
        stylesJardins.opacity = alpha

        Object.assign(this.dom.coverJardins.style, stylesJardins)
      }
      // TweenMax.set(this.dom.coverTitle, {
      //   // scale: this.motions.titleScale
      //   opacity: this.motions.titleOpacity
      // })
    } else {
      // this.hideDom()
      if (this.oldPosition !== -limitOutVp) {
        this.oldPosition = -limitOutVp
        this.dom.coverSection.style[this.prefix] = CSS.getMatrixTransform(0, this.oldPosition)
        this.soundManager.fadeIntro(0)
      }
    }
  }

  resize (size) {
    if (this.container.oldCacheAsBitmap) this.container.cacheAsBitmap = false
    this.size = size

    this.positionBackgroundCover()

    this.positionDom()
    this.getBounds()

    this.offsetHeight = this.size.h
    this.offsetHeight += this.bounds.coverContainer.height
    // this.offsetHeight += this.bounds.coverSpacer.height

    if (this.container.oldCacheAsBitmap) this.container.cacheAsBitmap = true
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Home/classes/Cover.js
 **/